import { render, staticRenderFns } from "./AppMarked.vue?vue&type=template&id=799f70e3"
import script from "./AppMarked.vue?vue&type=script&lang=js"
export * from "./AppMarked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports